export default "__VITE_PUBLIC_ASSET__6d623e3a__"